console.log("Lion Gang Empire music player loaded");

document.addEventListener("DOMContentLoaded", function () {
  const players = Array.from(document.querySelectorAll(".music-player"));
  const player = players[players.length - 1];

if (!player) {
  console.error("Music player HTML was not found.");
  return;
}

/*
 * Prevent this player from being initialized more than once.
 * Without this, one click can pause and immediately play again.
 */
if (player.dataset.musicPlayerInitialized === "true") {
  console.warn("Music player was already initialized.");
  return;
}

player.dataset.musicPlayerInitialized = "true";

  const audio = player.querySelector("#audio-player");
  const cover = player.querySelector("#player-cover");
  const title = player.querySelector("#player-title");
  const artist = player.querySelector("#player-artist");
  const status = player.querySelector("#player-status");
  const trackPosition = player.querySelector("#player-track-position");
  const nextUp = player.querySelector("#player-next-up");

  const playButton = player.querySelector("#play-song");
  const previousButton = player.querySelector("#prev-song");
  const nextButton = player.querySelector("#next-song");
  const shuffleButton = player.querySelector("#shuffle-player");
  const repeatButton = player.querySelector("#repeat-player");

  const progressBar = player.querySelector("#progress-bar");
  const currentTimeText = player.querySelector("#current-time");
  const durationText = player.querySelector("#duration");
  const volumeControl = player.querySelector("#volume");
  const volumeWrapper = player.querySelector(".player-volume");

  const volumeIcon = volumeWrapper
    ? volumeWrapper.querySelector(
        "button, .volume-icon, [data-volume-toggle]"
      )
    : null;

  const buyButton = player.querySelector("#buy-album");

  const queuePanel = player.querySelector("#player-queue");
  const queueList = player.querySelector("#queue-list");
  const queueCount = player.querySelector("#queue-count");
  const queueToggle = player.querySelector("#toggle-queue");
  const queueClose = player.querySelector("#close-queue");

  if (!audio || !playButton || !progressBar) {
    console.error("Required music player controls were not found.");
    return;
  }

  audio.preload = "auto";
  audio.setAttribute("playsinline", "");
  audio.setAttribute("webkit-playsinline", "");

  let playlist = [];
  let currentIndex = -1;
  let currentTrack = null;
  let shuffleEnabled = false;
  let repeatMode = "off";
  let previewEnded = false;
  let previousVolume = 1;
  let userPaused = false;

  const FAVORITES_KEY = "lge-player-favorites-v1";

  function formatTime(seconds) {
    if (!Number.isFinite(seconds) || seconds < 0) {
      return "0:00";
    }

    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);

    return (
      minutes +
      ":" +
      remainingSeconds.toString().padStart(2, "0")
    );
  }

  function escapeHtml(value) {
    return String(value || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function getTrackData(button) {
    let productUrl = button.dataset.productUrl || "";

    if (!productUrl && button.dataset.product) {
      productUrl = button.dataset.product.startsWith("/")
        ? button.dataset.product
        : "/products/" + button.dataset.product;
    }

    return {
      button: button,
      title: button.dataset.title || "Unknown Track",
      artist: button.dataset.artist || "",
      audio: button.dataset.audio || "",
      cover: button.dataset.cover || "",
      release:
        button.dataset.release ||
        button.dataset.album ||
        "",
      releaseType: button.dataset.releaseType || "",
      productUrl: productUrl,
      isPreview:
        button.dataset.preview === "true" ||
        button.dataset.preview === "1"
    };
  }

  function getAllPlayableButtons() {
    const buttons = Array.from(
      document.querySelectorAll(
        ".track-play-button, .featured-play"
      )
    ).filter(function (button) {
      return Boolean(button.dataset.audio);
    });

    return buttons.filter(function (
      button,
      index,
      allButtons
    ) {
      return (
        allButtons.findIndex(function (otherButton) {
          return (
            otherButton.dataset.audio ===
            button.dataset.audio
          );
        }) === index
      );
    });
  }

  function buildPlaylist(clickedButton) {
  const clickedTrack = getTrackData(clickedButton);

  const clickedRelease =
    clickedButton.dataset.release ||
    clickedButton.dataset.album ||
    "";

  const clickedAudio =
    clickedButton.dataset.audio || "";

  const allButtons = getAllPlayableButtons();

  if (clickedTrack.isPreview && clickedRelease) {
    playlist = allButtons.filter(function (button) {
      const buttonRelease =
        button.dataset.release ||
        button.dataset.album ||
        "";

      return buttonRelease === clickedRelease;
    });
  } else {
    playlist = allButtons.filter(function (button) {
      return (
        button.dataset.preview !== "true" &&
        button.dataset.preview !== "1"
      );
    });
  }

  if (!playlist.length) {
    playlist = [clickedButton];
  }

  currentIndex = playlist.findIndex(function (button) {
    return button.dataset.audio === clickedAudio;
  });

  if (currentIndex < 0) {
    playlist.unshift(clickedButton);
    currentIndex = 0;
  }

  renderQueue();
  updateTrackContext();
}

  function getTrackKey(track) {
    return track
      ? track.audio ||
          track.title + "|" + track.artist
      : "";
  }

  function readFavorites() {
    try {
      return (
        JSON.parse(
          localStorage.getItem(FAVORITES_KEY)
        ) || []
      );
    } catch (error) {
      return [];
    }
  }

  function writeFavorites(favorites) {
    localStorage.setItem(
      FAVORITES_KEY,
      JSON.stringify(favorites)
    );
  }

  function updateBuyButton(track) {
    if (!buyButton) return;

    buyButton.classList.remove(
      "is-preview-ready"
    );

    if (
      !track ||
      !track.productUrl ||
      !track.isPreview
    ) {
      buyButton.hidden = true;
      buyButton.onclick = null;
      return;
    }

    const type = String(
      track.releaseType || ""
    ).toLowerCase();

    if (type.includes("album")) {
      buyButton.textContent = "Buy Album";
    } else if (type.includes("mixtape")) {
      buyButton.textContent = "Buy Mixtape";
    } else if (type.includes("single")) {
      buyButton.textContent = "Buy Single";
    } else {
      buyButton.textContent = "Buy Release";
    }

    buyButton.hidden = false;

    buyButton.onclick = function () {
      window.location.href = track.productUrl;
    };
  }

  function clearStatus() {
    previewEnded = false;

    if (status) {
      status.textContent = "";
      status.classList.remove(
        "is-preview-ended"
      );
    }

    if (buyButton) {
      buyButton.classList.remove(
        "is-preview-ready"
      );
    }
  }

  function showPreviewEndedMessage() {
    previewEnded = true;

    if (status) {
      status.innerHTML =
        "<strong>Preview ended.</strong> Purchase to continue.";

      status.classList.add(
        "is-preview-ended"
      );
    }

    if (
      buyButton &&
      currentTrack &&
      currentTrack.productUrl
    ) {
      buyButton.hidden = false;
      buyButton.classList.add(
        "is-preview-ready"
      );
    }
  }

  function clearPlayingIndicators() {
    document
      .querySelectorAll(
        ".track-play-button.is-playing"
      )
      .forEach(function (button) {
        button.classList.remove("is-playing");

        const icon = button.querySelector(
          ".track-row__play-icon"
        );

        if (icon) {
          icon.textContent = "▶";
        }
      });

    document
      .querySelectorAll(
        ".featured-play.is-playing"
      )
      .forEach(function (button) {
        button.classList.remove("is-playing");
        button.textContent =
          "▶ Play Preview";
      });
  }

  function updatePlayingIndicator() {
    clearPlayingIndicators();

    if (!currentTrack || audio.paused) {
      return;
    }

    getAllPlayableButtons()
      .filter(function (button) {
        return (
          button.dataset.audio ===
          currentTrack.audio
        );
      })
      .forEach(function (button) {
        button.classList.add("is-playing");

        if (
          button.classList.contains(
            "track-play-button"
          )
        ) {
          const icon = button.querySelector(
            ".track-row__play-icon"
          );

          if (icon) {
            icon.textContent = "❚❚";
          }
        }

        if (
          button.classList.contains(
            "featured-play"
          )
        ) {
          button.textContent = "❚❚ Pause";
        }
      });
  }

  function updateTrackContext() {
    if (queueCount) {
      queueCount.textContent = String(
        playlist.length
      );
    }

    if (
      !playlist.length ||
      currentIndex < 0
    ) {
      if (trackPosition) {
        trackPosition.textContent = "";
      }

      if (nextUp) {
        nextUp.textContent = "";
      }

      return;
    }

    if (trackPosition) {
      trackPosition.textContent =
        "Track " +
        (currentIndex + 1) +
        " of " +
        playlist.length;
    }

    if (nextUp && playlist.length > 1) {
      const nextIndex =
        currentIndex + 1 < playlist.length
          ? currentIndex + 1
          : 0;

      const nextTrack = getTrackData(
        playlist[nextIndex]
      );

      nextUp.textContent =
        "Next Up: " + nextTrack.title;
    } else if (nextUp) {
      nextUp.textContent = "";
    }
  }

  function renderQueue() {
    updateTrackContext();

    if (!queueList) return;

    queueList.innerHTML = "";

    if (!playlist.length) {
      queueList.innerHTML =
        '<p class="player-queue__empty">Select a song to create a queue.</p>';

      return;
    }

    playlist.forEach(function (
      button,
      index
    ) {
      const track = getTrackData(button);
      const item =
        document.createElement("button");

      item.type = "button";
      item.className =
        "player-queue__item";

      item.dataset.queueIndex =
        String(index);

      if (index === currentIndex) {
        item.classList.add("is-current");
      }

      item.innerHTML =
        '<span class="player-queue__number">' +
        (index + 1) +
        "</span>" +
        (track.cover
          ? '<img src="' +
            escapeHtml(track.cover) +
            '" alt="">'
          : '<span class="player-queue__cover-placeholder"></span>') +
        '<span class="player-queue__meta">' +
        "<strong>" +
        escapeHtml(track.title) +
        "</strong>" +
        "<small>" +
        escapeHtml(track.artist) +
        "</small>" +
        "</span>" +
        '<span class="player-queue__state">' +
        (index === currentIndex
          ? audio.paused
            ? "Selected"
            : "Playing"
          : "Play") +
        "</span>";

      queueList.appendChild(item);
    });
  }

  function updateMediaSession(track) {
    if (
      !("mediaSession" in navigator) ||
      !track
    ) {
      return;
    }

    try {
      navigator.mediaSession.metadata =
        new MediaMetadata({
          title: track.title,
          artist: track.artist,
          album:
            track.release ||
            "Lion Gang Empire",
          artwork: track.cover
            ? [
                {
                  src: track.cover,
                  sizes: "512x512",
                  type: "image/jpeg"
                }
              ]
            : []
        });
    } catch (error) {
      console.warn(
        "Media Session metadata was not set.",
        error
      );
    }
  }

  function updateDurationDisplay() {
    if (!durationText || !currentTrack) {
      return;
    }

    if (
      !Number.isFinite(audio.duration) ||
      audio.duration <= 0
    ) {
      return;
    }

    const playableDuration =
      currentTrack.isPreview
        ? Math.min(30, audio.duration)
        : audio.duration;

    durationText.textContent =
      formatTime(playableDuration);
  }

  function loadTrack(button, autoplay) {
  const track = getTrackData(button);
  userPaused = false;
    const shouldAutoplay =
      autoplay !== false;

    if (!track.audio) {
      if (status) {
        status.textContent =
          "Audio has not been added to this track.";
      }

      return;
    }

    currentTrack = track;

const requestedAudio = track.audio;

if (audio.dataset.loadedAudio !== requestedAudio) {
  audio.src = requestedAudio;
  audio.dataset.loadedAudio = requestedAudio;
}

audio.currentTime = 0;

player.classList.add("has-track");
    clearStatus();

    if (cover) {
  if (
    track.cover &&
    cover.dataset.loadedCover !== track.cover
  ) {
    cover.src = track.cover;
    cover.dataset.loadedCover = track.cover;
  }

  cover.alt = track.title;
}
    if (title) {
      title.textContent = track.title;
    }

    if (artist) {
      artist.textContent = track.artist;
    }

    progressBar.value = 0;

    if (currentTimeText) {
      currentTimeText.textContent = "0:00";
    }

    if (durationText) {
      durationText.textContent = "0:00";
    }
    
    updateBuyButton(track);
    updateTrackContext();
    renderQueue();
    updateMediaSession(track);

    if (volumeWrapper) {
      volumeWrapper.hidden = false;
    }

    if (shouldAutoplay) {
      audio.play().catch(function (error) {
        console.error(
          "Audio could not start:",
          error
        );

        if (status) {
          status.textContent =
            "Tap play to begin listening.";
        }
      });
    }
  }

  function playCurrentTrack() {
  userPaused = false;
  clearStatus();

    if (!currentTrack) {
      const firstTrack =
        getAllPlayableButtons()[0];

      if (!firstTrack) {
        if (status) {
          status.textContent =
            "Select a track to begin listening.";
        }

        return;
      }

      buildPlaylist(firstTrack);
      loadTrack(firstTrack, true);
      return;
    }

    audio.play().catch(function (error) {
      console.error(
        "Audio playback failed:",
        error
      );

      if (status) {
        status.textContent =
          "Tap a song first, then press play.";
      }
    });
  }

  function getRandomNextIndex() {
    if (playlist.length <= 1) {
      return currentIndex;
    }

    let nextIndex = currentIndex;

    while (nextIndex === currentIndex) {
      nextIndex = Math.floor(
        Math.random() * playlist.length
      );
    }

    return nextIndex;
  }

  function playNextTrack(fromEnded) {
  if (!playlist.length) return;

  if (
    fromEnded &&
    repeatMode === "one"
  ) {
    audio.currentTime = 0;

    audio.play().catch(function (error) {
      console.error(
        "Audio playback failed:",
        error
      );
    });

    return;
  }

  let nextIndex = shuffleEnabled
    ? getRandomNextIndex()
    : currentIndex + 1;

  if (nextIndex >= playlist.length) {
    if (
      repeatMode === "all" ||
      !fromEnded
    ) {
      nextIndex = 0;
    } else {
      audio.pause();
      audio.currentTime = 0;
      progressBar.value = 0;

      if (currentTimeText) {
        currentTimeText.textContent = "0:00";
      }

      playButton.textContent = "▶";
      renderQueue();
      updateTrackContext();
      return;
    }
  }

  currentIndex = nextIndex;

  loadTrack(
    playlist[currentIndex],
    true
  );
}

  function playPreviousTrack() {
  if (!playlist.length) return;

  currentIndex -= 1;

  if (currentIndex < 0) {
    currentIndex = playlist.length - 1;
  }

  loadTrack(
    playlist[currentIndex],
    true
  );
}

  document.addEventListener(
  "click",
  function (event) {
        if (event.target.closest("#play-song")) {
      return;
    }
    /*
     * Do not intercept clicks on the bottom music player.
     * Its buttons have their own controls.
     */
    if (event.target.closest(".music-player")) {
      return;
    }

    const trackButton =
      event.target.closest(
        ".track-play-button, .featured-play"
      );

      if (
        trackButton &&
        trackButton.dataset.audio
      ) {
        event.preventDefault();
        event.stopPropagation();

        const clickedAudio =
          trackButton.dataset.audio;

        if (
          currentTrack &&
          currentTrack.audio ===
            clickedAudio
        ) {
          if (audio.paused) {
            playCurrentTrack();
          } else {
            audio.pause();
          }

          return;
        }

        buildPlaylist(trackButton);
        loadTrack(trackButton, true);
        return;
      }

      const playAllButton =
        event.target.closest(
          ".release-play-all"
        );

      if (playAllButton) {
        event.preventDefault();

        const releaseHandle =
          playAllButton.dataset.release || "";

        playlist =
          getAllPlayableButtons().filter(
            function (button) {
              return (
                (button.dataset.release ||
                  button.dataset.album ||
                  "") === releaseHandle
              );
            }
          );

        if (!playlist.length) {
          if (status) {
            status.textContent =
              "No playable tracks were found.";
          }

          return;
        }

        currentIndex = 0;
        loadTrack(playlist[0], true);
        return;
      }

      const releaseShuffle =
        event.target.closest(
          ".release-shuffle"
        );

      if (releaseShuffle) {
        event.preventDefault();

        const releaseHandle =
          releaseShuffle.dataset.release ||
          "";

        playlist =
  getAllPlayableButtons().filter(
    function (button) {
      const isLockedPreview =
        button.dataset.preview === "true" ||
        button.dataset.preview === "1";

      return (
        !isLockedPreview &&
        (button.dataset.release ||
          button.dataset.album ||
          "") === releaseHandle
      );
    }
  );

        if (!playlist.length) {
          return;
        }

        playlist.sort(function () {
          return Math.random() - 0.5;
        });

        currentIndex = 0;
        loadTrack(playlist[0], true);
      }
        },
    false
  );

  playButton.addEventListener(
  "click",
  function (event) {
    event.preventDefault();
    event.stopPropagation();

    if (audio.paused) {
      userPaused = false;
      playCurrentTrack();
    } else {
      userPaused = true;

      document
        .querySelectorAll(".music-player audio")
        .forEach(function (playerAudio) {
          playerAudio.pause();
        });
    }
  }
);

  previousButton.addEventListener("click", function (event) {
  event.preventDefault();
  playPreviousTrack();
});

  nextButton.addEventListener("click", function (event) {
  event.preventDefault();
  playNextTrack(false);
});

  if (shuffleButton) {
    shuffleButton.addEventListener(
      "click",
      function () {
        shuffleEnabled =
          !shuffleEnabled;

        shuffleButton.classList.toggle(
          "is-active",
          shuffleEnabled
        );

        shuffleButton.setAttribute(
          "aria-label",
          shuffleEnabled
            ? "Shuffle on"
            : "Shuffle off"
        );
      }
    );
  }

  if (repeatButton) {
    repeatButton.addEventListener(
      "click",
      function () {
        if (repeatMode === "off") {
          repeatMode = "all";
          repeatButton.textContent = "🔁";
          repeatButton.title =
            "Repeat all";
        } else if (
          repeatMode === "all"
        ) {
          repeatMode = "one";
          repeatButton.textContent = "🔂";
          repeatButton.title =
            "Repeat one";
        } else {
          repeatMode = "off";
          repeatButton.textContent = "🔁";
          repeatButton.title =
            "Repeat off";
        }

        repeatButton.dataset.repeatMode =
          repeatMode;

        repeatButton.classList.toggle(
          "is-active",
          repeatMode !== "off"
        );

        repeatButton.setAttribute(
          "aria-label",
          repeatButton.title
        );
      }
    );
  }

  if (queueToggle && queuePanel) {
    queueToggle.addEventListener(
      "click",
      function () {
        const isOpen =
          queuePanel.classList.toggle(
            "is-open"
          );

        queuePanel.setAttribute(
          "aria-hidden",
          isOpen ? "false" : "true"
        );

        queueToggle.setAttribute(
          "aria-expanded",
          isOpen ? "true" : "false"
        );
      }
    );
  }

  if (
    queueClose &&
    queuePanel &&
    queueToggle
  ) {
    queueClose.addEventListener(
      "click",
      function () {
        queuePanel.classList.remove(
          "is-open"
        );

        queuePanel.setAttribute(
          "aria-hidden",
          "true"
        );

        queueToggle.setAttribute(
          "aria-expanded",
          "false"
        );
      }
    );
  }

  if (queueList) {
    queueList.addEventListener(
      "click",
      function (event) {
        const item =
          event.target.closest(
            ".player-queue__item"
          );

        if (!item) return;

        const index = Number(
          item.dataset.queueIndex
        );

        if (
          !Number.isInteger(index) ||
          index < 0 ||
          index >= playlist.length
        ) {
          return;
        }

        currentIndex = index;

        loadTrack(
          playlist[currentIndex],
          true
        );
      }
    );
  }

  document.addEventListener(
  "play",
  function (event) {
    const playedAudio = event.target;

    if (
      userPaused &&
      playedAudio instanceof HTMLMediaElement &&
      playedAudio.closest(".music-player")
    ) {
      playedAudio.pause();
    }
  },
  true
);

  audio.addEventListener(
    "play",
    function () {
      playButton.textContent = "❚❚";

      playButton.setAttribute(
        "aria-label",
        "Pause"
      );

      updatePlayingIndicator();
      renderQueue();
    }
  );

  audio.addEventListener(
    "pause",
    function () {
      playButton.textContent = "▶";

      playButton.setAttribute(
        "aria-label",
        "Play"
      );

      clearPlayingIndicators();
      renderQueue();
    }
  );

  audio.addEventListener("ended", function () {
  playNextTrack(true);
});

  audio.addEventListener(
    "loadedmetadata",
    updateDurationDisplay
  );

  audio.addEventListener(
    "durationchange",
    updateDurationDisplay
  );

  audio.addEventListener(
    "canplay",
    updateDurationDisplay
  );

  audio.addEventListener(
    "timeupdate",
    function () {
      if (!currentTrack) return;

      const realDuration =
        Number.isFinite(audio.duration)
          ? audio.duration
          : 0;

      const playableDuration =
        currentTrack.isPreview
          ? Math.min(
              30,
              realDuration || 30
            )
          : realDuration;

      if (currentTimeText) {
        currentTimeText.textContent =
          formatTime(audio.currentTime);
      }

      if (
        durationText &&
        playableDuration > 0
      ) {
        durationText.textContent =
          formatTime(playableDuration);
      }

      if (playableDuration > 0) {
        progressBar.value = Math.min(
          100,
          (audio.currentTime /
            playableDuration) *
            100
        );
      }

if (
  currentTrack.isPreview &&
  !previewEnded &&
  audio.currentTime >= playableDuration
) {
  previewEnded = true;

  const hasAnotherTrack =
    currentIndex < playlist.length - 1;

  const shouldLoop =
    repeatMode === "all";

  audio.pause();
  audio.currentTime = 0;
  progressBar.value = 0;

  if (currentTimeText) {
    currentTimeText.textContent = "0:00";
  }

  if (hasAnotherTrack || shouldLoop) {
    playNextTrack(true);
  } else {
    showPreviewEndedMessage();
    renderQueue();
    updateTrackContext();
  }
}

});

  progressBar.addEventListener(
    "input",
    function () {
      if (
        !currentTrack ||
        !Number.isFinite(audio.duration) ||
        audio.duration <= 0
      ) {
        return;
      }

      const playableDuration =
        currentTrack.isPreview
          ? Math.min(30, audio.duration)
          : audio.duration;

      audio.currentTime =
        (Number(progressBar.value) /
          100) *
        playableDuration;
    }
  );

  function updateVolumeIcon() {
    if (!volumeIcon) return;

    const muted =
      audio.muted ||
      audio.volume === 0;

    volumeIcon.textContent = muted
      ? "🔇"
      : "🔊";

    volumeIcon.setAttribute(
      "aria-label",
      muted ? "Unmute" : "Mute"
    );
  }

  if (volumeControl) {
    const startingVolume =
      Number(volumeControl.value) / 100;

    audio.volume =
      Number.isFinite(startingVolume)
        ? startingVolume
        : 1;

    previousVolume =
      audio.volume > 0
        ? audio.volume
        : 1;

    volumeControl.addEventListener(
      "input",
      function () {
        const newVolume =
          Number(volumeControl.value) /
          100;

        audio.volume = newVolume;
        audio.muted =
          newVolume === 0;

        if (newVolume > 0) {
          previousVolume = newVolume;
        }

        updateVolumeIcon();
      }
    );
  }

  if (volumeIcon) {
    volumeIcon.addEventListener(
      "click",
      function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (
          audio.muted ||
          audio.volume === 0
        ) {
          audio.muted = false;

          audio.volume =
            previousVolume || 1;

          if (volumeControl) {
            volumeControl.value = String(
              audio.volume * 100
            );
          }
        } else {
          previousVolume =
            audio.volume;

          audio.muted = true;
        }

        updateVolumeIcon();
      }
    );
  }

  audio.addEventListener(
  "volumechange",
  updateVolumeIcon
);


if ("mediaSession" in navigator) {
    try {
      navigator.mediaSession.setActionHandler(
        "play",
        playCurrentTrack
      );

      navigator.mediaSession.setActionHandler(
        "pause",
        function () {
          audio.pause();
        }
      );

      navigator.mediaSession.setActionHandler(
        "previoustrack",
        playPreviousTrack
      );

      navigator.mediaSession.setActionHandler(
        "nexttrack",
        function () {
          playNextTrack(false);
        }
      );
    } catch (error) {
      console.warn(
        "Media Session controls were not registered.",
        error
      );
    }
  }

  if (title) {
  title.textContent = "Independent Music Platform";
  title.style.fontSize = "13px";
}

if (artist) {
  artist.textContent = "Lion Gang Empire";
  artist.style.fontSize = "11px";
}

  playButton.textContent = "▶";

  if (buyButton) {
    buyButton.hidden = true;
  }

  if (volumeWrapper) {
    volumeWrapper.hidden = false;
  }

  player.classList.remove("has-track");

  updateVolumeIcon();
  renderQueue();
})